import React from "react";
import "tailwindcss/tailwind.css";
import NoDataFound from "../NoDataFound";
import CustomTooltip from "./ToolTip";



type RowData = {
  [key: string]: string;
};

interface TableProps {
  data: string;
  handleAction?: () => void;
}

// Helper function to parse CSV row respecting quoted values
const parseCSVRow = (row: string): string[] => {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < row.length; i++) {
    const char = row[i];

    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result;
};

// String-based compact formatter to avoid JS Number precision loss
const formatCompactString = (value: string): string => {
  const isNeg = value.startsWith('-');
  const abs = isNeg ? value.slice(1) : value;
  const dotIdx = abs.indexOf('.');
  const intPart = dotIdx === -1 ? abs : abs.slice(0, dotIdx);
  const len = intPart.length;

  const suffixes: [number, string, number][] = [
    [13, 'T', 12], [10, 'B', 9], [7, 'M', 6], [5, 'K', 3],
  ];

  for (const [minLen, suffix, power] of suffixes) {
    if (len >= minLen) {
      const cutAt = len - power;
      const main = intPart.slice(0, cutAt);
      const frac = intPart.slice(cutAt, cutAt + 2).replace(/0+$/, '');
      const formatted = frac ? `${main}.${frac}${suffix}` : `${main}${suffix}`;
      return isNeg ? `-${formatted}` : formatted;
    }
  }

  return value;
};

const formatCellValue = (value: string): { display: string; full: string | null } => {
  if (value === '' || value === '-') {
    return { display: value, full: null };
  }
  const num = Number(value);
  if (isNaN(num)) {
    return { display: value, full: null };
  }
  if (Math.abs(num) >= 10000) {
    return {
      display: formatCompactString(value),
      full: value,
    };
  }
  return { display: value, full: null };
};

const Table: React.FC<TableProps> = ({ data, handleAction }) => {
  const rows = data.trim().split('\n').map(row => parseCSVRow(row));

  let headers = rows[0].map(header => header.trim());

  const rowData: RowData[] = rows.slice(1).map((row) => {
    const data: RowData = {};
    headers.forEach((header, headerIndex) => {
      if (header !== "Publisher") {
        data[header] = row[headerIndex]?.trim() || '-';
      }
    });
    return data;
  });
  headers = headers.filter(header => header !== "Publisher");

  return (
    <>
      {rowData?.length ? (
        <>
          
          <div className="overflow-x-scroll custom-scrollbar scrollbar-thin scrollbar-thumb-[#424242] scrollbar-track-[#1C1C1C] rounded-md">

            <div className="w-[fit-content] sm:min-w-full text-left bg-[#111111] rounded-[12px] md:rounded-[16px]">
              {/* Header */}
              <div className="flex text-[#A1A1A1] ">
                {headers.map((header, index) => (
                  <div
                    key={index}
                    // className="flex-1 min-w-[137px] w-[max-content] p-4 py-4 font-popins"
                    className={`${header === "Domain" || header === "MobileAppId" ? "w-[250px]" : header === "Gross Revenue ($)" ? "w-[170px]" : "w-[137px]"} p-4 py-4 font-popins whitespace-nowrap`}                  >
                    {header}
                  </div>
                ))}
              </div>
              {/* Body */}
              <div className="overflow-y-hidden">
                {rowData.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="flex border-none hover:bg-[#0B0B0B] transition-all duration-200 h-[60px] items-center rounded-[13px] mx-[4px]"
                  >


{headers.map((header, headerIndex) => (
  <div
    key={headerIndex}
    className={`${header === "Domain" || header === "MobileAppId" ? "w-[250px]" : header === "Gross Revenue ($)" ? "w-[170px]" : "w-[137px]"} p-4 py-4 font-popins`}  >
    {header === "Domain" || header === "MobileAppId" ? (
      <CustomTooltip content={row[header]?.length > 23 ? row[header] : ""}>
        <div>
          {row[header]?.length > 23 ? `${row[header].slice(0, 23)}...` : row[header]}
        </div>
      </CustomTooltip>
    ) : (() => {
      const { display, full } = formatCellValue(row[header]);
      return full ? (
        <CustomTooltip content={full}>
          <div>{display}</div>
        </CustomTooltip>
      ) : (
        display || '-'
      );
    })()}
  </div>
))}

                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default Table;
